import References from './Reference';

function TokenException( message ) {
		this.message = message;		
}

export default class AuthService {

	static getHeaders = ( data ) => {
		return {
			    method: "POST",
			    headers: {
			      "Content-Type": "application/json"
			    },
			    body: JSON.stringify( data ), // body data type must match "Content-Type" heade

		}
	}
	
	static async login( login, password ) {	
/*		let login = 'debug';
		let password = 'AWs45-zx';*/
		let data = {"username": login, "password": password};
		return fetch(
			References.api.login, 
			AuthService.getHeaders( data )
		)
		.then(response => response.json())
	}

	static async logout() {
		let data = {"refresh": localStorage.getItem('refresh_token')};
		fetch(
			References.api.logout, 
			AuthService.getHeaders( data )
		)
		localStorage.removeItem('access_token');
		localStorage.removeItem('refresh_token');
	}


	static async saveTokens( access, refresh ) {
		localStorage.setItem('access_token', access);
		localStorage.setItem('refresh_token', refresh);
	}

	static isAuth() {		
		return localStorage.getItem('access_token') != null && localStorage.getItem('refresh_token') != null ? true : false;
	}	

	static isForciblyAuth() {
		return this.getAccessToken()
			.then( data => {		
				return !data.hasOwnProperty('code') || data.code != 'token_not_valid';
			})
			.catch(() => {
				return false
			});		
	}

	static async refresh() {
		let data = {"refresh": localStorage.getItem('refresh_token')};
		try {
			return fetch(
				References.api.refresh,
				AuthService.getHeaders( data )			
			)
			.then( response => response.json());			
			
		} catch (e) {
			console.log( e.message );
		}
	}

	static async check( token ) {		
		let data = {"token": localStorage.getItem( 'access_token' )};
		return fetch(
				References.api.check, 
				AuthService.getHeaders( data )
			)
		.then(response => response.json())
	}

	static async getAccessToken() {
		let access = localStorage.getItem( 'access_token' );
		let refresh = localStorage.getItem( 'refresh_token' );

		if (!access || !refresh)
			throw new Error('no_keys');			

		return this.check()
			.then( data => {
				if (data.hasOwnProperty('code') && data.code == 'token_not_valid')
					return AuthService.refresh();
				else {
					return {
						"access": localStorage.getItem('access_token')
					}
				}
			});

	}

	static fetch( url ) {
		return this.getAccessToken()
			.then( data => {	
					if (data.hasOwnProperty('access'))
						AuthService.saveTokens( data.access, localStorage.getItem('refresh_token') );

					return fetch( url, {
						"headers": {						
							"Authorization": "Bearer " + data.access
						}
					});
				}
			)
	}

	static async fetchAll( urls ) {
		return this.getAccessToken()
			.then( data => {	
					if (data.hasOwnProperty('access'))
						AuthService.saveTokens( data.access, localStorage.getItem('refresh_token') );

					return Promise.all(urls.map(url => fetch(url, {
						"headers": {						
							"Authorization": "Bearer " + data.access
						}
					})))

/*					return fetch( url, {
						"headers": {						
							"Authorization": "Bearer " + data.access
						}
					});*/
				}
			)
	}	

}